import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

interface UseGenerateLabelParams {
	onSuccess?: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
}

export default function useGenerateLabel(params: UseGenerateLabelParams) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/generate-label",
	);
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useMutation({
		onSuccess: (returnRequest: ReturnRequestDto) => {
			successNotification();
			invalidateReturnRequest({
				returnRequestId: returnRequest.id,
				shopId: returnRequest.shopId,
			});
			if (params.onSuccess) {
				params.onSuccess(returnRequest);
			}
		},
		onError: (error) => {
			errorNotification();
			params.onError?.(error);
		},
		mutationFn: (body: { shopId: string; returnRequestId: string }) => {
			return mutation.mutateAsync({
				params: {
					path: { shopId: body.shopId, returnRequestId: body.returnRequestId },
				},
			});
		},
	});
}
